import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Status } from '~/app/core/configs/status';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  constructor(private http: HttpService) {}

  sendRequest(request: any): Observable<any> {
    return this.http.post(`/requests`, request);
  }
  searchCompanies(
    persona,
    offset,
    limit,
    countryId?,
    product?,
    sort?
  ): Observable<any> {
    const params = {
      offset,
      limit,
      sort:
        sort && sort.direction
          ? `${sort.active} ${sort.direction.toUpperCase()}`
          : 'name',
      persona,
      where: {
        or: [
          { name: { ilike: `%${product}%` } },
          { services: { ilike: `%${product}%` } },
        ],
        country_id: countryId,
      },
    };
    if (!countryId) {
      delete params.where.country_id;
    }
    if (!product) {
      delete params.where.or;
    }
    if (!product && !countryId) {
      delete params.where;
    }
    return this.http.get(`/companies`, params);
  }

  searchShipperById(identifier): Observable<any> {
    return this.http.get(`/companies/${identifier}`);
  }

  searchRequest(
    persona,
    offset,
    limit,
    status?,
    identifier?,
    name?,
    sort?
  ): Observable<any> {
    const params = {
      offset,
      limit,
      sort:
        sort && sort.direction
          ? `${sort.active} ${sort.direction.toUpperCase()}`
          : 'modified_date DESC',
      persona,
      q: name || identifier || '',
      where: {
        status,
      },
    };
    if (status === undefined || status < 0) {
      delete params.where.status;
    }
    if (status === undefined || status < 0) {
      delete params.where;
    }
    return this.http.get(`/requests`, params);
  }

  deleteRequest(id): Observable<any> {
    return this.http.delete(`/requests/${id}`);
  }

  getRequestDetail(id): Observable<any> {
    return this.http.get(`/requests/${id}`);
  }

  updateRequestDocument(requestId, name, pathS3): Observable<any> {
    return this.http.post(`/requests/${requestId}/documents`, {
      documents: [
        {
          name,
          document: pathS3,
        },
      ],
    });
  }

  deleteDocumentInRequest(requestId, documentId): Observable<any> {
    return this.http.delete(`/requests/${requestId}/documents/${documentId}`);
  }

  sendQuoteOfRequest(requestId, name, document): Observable<any> {
    return this.http.patch(`/requests/${requestId}`, { status: Status.Request.QuoteSent, quotation: JSON.stringify({name, document})});
  }

  denyRequest(requestId): Observable<any> {
    return this.http.patch(`/requests/${requestId}`, { status: Status.Request.RequestDenied });
  }

  denyQuoteOfRequest(requestId, remarks): Observable<any> {
    return this.http.patch(`/requests/${requestId}`, { status: Status.Request.QuoteDenied, remarks });
  }
  acceptQuoteOfRequest(requestId, remarks): Observable<any> {
    return this.http.patch(`/requests/${requestId}`, { status: Status.Request.QuoteAccepted, remarks });
  }

  saveRemarksRequest(requestId, remarks): Observable<any> {
    return this.http.patch(`/requests/${requestId}`, { remarks });
  }

  getCommentsById(requestId): Observable<any> {
    return this.http.get(`/requests/${requestId}/comments`, {sort: 'created_date ASC'}, {
      headers: { ignoreLoadingBar: '' },
    });
  }

  postComment(requestId, params): Observable<any> {
    return this.http.post(`/requests/${requestId}/comments`, params, {
      headers: { ignoreLoadingBar: '' },
    });
  }
}
